export const CREATE_ACTIONS_CENTER = 'CREATE_ACTIONS_CENTER';
export const GET_ACTIONS_CENTER = 'GET_ACTIONS_CENTER';
export const UPDATE_ACTIONS_CENTER = 'UPDATE_ACTIONS_CENTER';
export const GET_PUBLISHER_ACTIONS_CENTER = 'GET_PUBLISHER_ACTIONS_CENTER';
export const GET_BRAND_ACTIVITY = 'GET_BRAND_ACTIVITY';